/**
 * Resolve an icon id to the sprite file that holds it.
 *
 * The server prints window.__svgSprites = { files: [url, ...], ids: { id: fileIndex } }
 * for every sprite hoisted with hoist('svg', ...). When the id is not hoisted
 * (sprite inlined in the page, or no map at all) this returns "#id", which
 * resolves against the inline copy.
 *
 * @param {string} id Symbol id without "#".
 * @returns {string}
 */
export function spriteHref(id) {
    const sprites = typeof window !== 'undefined' ? window.__svgSprites : null;
    if (sprites && sprites.ids && Object.prototype.hasOwnProperty.call(sprites.ids, id)) {
        const file = sprites.files[sprites.ids[id]];
        if (file) {
            return file + '#' + id;
        }
    }
    return '#' + id;
}

/**
 * Vue 3 plugin: exposes spriteHref() to every template.
 *
 *   app.use(svgSprite)
 *   <svg viewBox="0 0 24 24"><use :xlink:href="spriteHref('close')"></use></svg>
 */
export default {
    install(app) {
        app.config.globalProperties.spriteHref = spriteHref;
    },
};
